import axios from 'axios';
import { facebookRequest } from '@php-beam/packages/frontend/src/support/facebook';

export const client = axios.create({
  baseURL: import.meta.env.VITE_URL,
});

export const facebookClient = {
  get: <T extends object>(path: string, params: Record<string, string> = {}) =>
    facebookRequest<T>(path, 'get', params),
  post: <T extends object>(path: string, params: Record<string, string> = {}) =>
    facebookRequest<T>(path, 'post', params),
  delete: <T extends object>(
    path: string,
    params: Record<string, string> = {},
  ) => facebookRequest<T>(path, 'delete', params),
};
